import { render, staticRenderFns } from "./PageError.vue?vue&type=template&id=1a2efc36&"
import script from "./PageError.vue?vue&type=script&lang=js&"
export * from "./PageError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/bluehost-site-migrator/bluehost-site-migrator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2efc36')) {
      api.createRecord('1a2efc36', component.options)
    } else {
      api.reload('1a2efc36', component.options)
    }
    module.hot.accept("./PageError.vue?vue&type=template&id=1a2efc36&", function () {
      api.rerender('1a2efc36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "source/components/PageError.vue"
export default component.exports